module.exports = __webpack_public_path__ + "img/serveLogo4.4d6b9e17.png";